import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { markupProfileListSelector } from './markupProfileList.selector';

export const markupProfileNamesSelector = createCachedSelector(
  [
    path(markupProfileListSelector).list(),
  ],
  (profileList) => new Set(profileList.map((markup) => markup.markupProfileName)),
)({
  keySelector: defaultKeySelector,
});
